import { createContext, useContext } from 'react';

import type { ViewerMode } from 'constants/all';

/**
 * The kind of account the viewer is using (see GLOSSARY.md). A Part Viewer
 * account has no quoting tool.
 */
export const VIEWER_ACCOUNTS = {
  QUOTING: 'quoting',
  PART_VIEWER: 'partViewer',
} as const;

export type ViewerAccount =
  (typeof VIEWER_ACCOUNTS)[keyof typeof VIEWER_ACCOUNTS];

/**
 * The user's relationship to the part being shown, and what their account is.
 * A shared part is viewed through someone else's share grant.
 */
export type ViewerAccess = {
  relationship: ViewerMode;
  /** The viewer's own active account, even on a part shared by someone else. */
  account: ViewerAccount;
};

export const ViewerAccessContext = createContext<ViewerAccess | null>(null);

export const useViewerAccess = (): ViewerAccess => {
  const value = useContext(ViewerAccessContext);
  if (value === null) {
    throw new Error('ViewerAccess must be provided by the viewer host');
  }
  return value;
};
